import Vue from "vue";
import Vuex from "vuex";
import ApiService from "@/services/ApiService.js";
import AuthService from "../services/AuthService";
import UserService from "../services/UserService";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== "production",
  state: {
    user: null,
    snackbar: {
      message: "",
      color: ""
    }
  },
  mutations: {
    SET_USER_DATA(state, userData) {
      state.user = userData;
      localStorage.setItem("user", JSON.stringify(userData));
    },

    UPDATE_USER_PHOTO(state, photoId) {
      state.user.photoId = photoId;
      localStorage.setItem("user", JSON.stringify(state.user));
    },
    UPDATE_USER_DATA(state, userData) {
      userData.token = state.user.token;
      state.user = userData;
      localStorage.setItem("user", JSON.stringify(userData));
    },
    UPDATE_USER_ACCEPT(state) {
      state.user.privacyStatementAccepted = true;
      localStorage.setItem("user", JSON.stringify(state.user));
    },
    CLEAR_USER_DATA() {
      localStorage.removeItem("user");
      localStorage.removeItem("location");
      location.reload();
    },
    SNACK(state, config) {
      state.snackbar.color = config.color;
      state.snackbar.message = config.message;
    }
  },
  actions: {
    login({ commit }, credentials) {
      return AuthService.postLogin(credentials).then(({ data }) => {
        commit("SET_USER_DATA", data);
      });
    },
    refreshToken({ commit }, tokens) {
      return AuthService.refreshAuthToken(tokens)
        .then(({ data }) => {
          commit("SET_USER_DATA", data);
        })
        .catch(() => {
          commit("CLEAR_USER_DATA");
        });
    },
    logout({ commit }) {
      commit("CLEAR_USER_DATA");
    },
    updateUserPhoto({ commit }, formData) {
      return ApiService.postProfilePicture(formData).then(({ data }) => {
        commit("UPDATE_USER_PHOTO", data);
      });
    },
    updateUser({ commit }, userDetails) {
      return ApiService.postUserUpdate(userDetails).then(({ data }) => {
        commit("UPDATE_USER_DATA", data);
      });
    },
    userAccept({ commit }) {
      return UserService.userAccept().then(() => {
        commit("UPDATE_USER_ACCEPT");
      });
    },
    snackInfo({ commit }, message) {
      commit("SNACK", { message: message, color: "info" });
    },
    snackError({ commit }, message) {
      commit("SNACK", { message: message, color: "error" });
    },
    snackSuccess({ commit }, message) {
      commit("SNACK", { message: message, color: "success" });
    }
  },
  getters: {
    loggedIn(state) {
      return !!state.user;
    },
    checkLocation(state) {
      return state.location;
    }
  }
});
